<div>
  <div class="page-not-found-container">
    <span class="page-not-found">Page Not Found</span>
    <p>Oops, we couldn't find the page you were looking for.</p>
    <div class="helpline">
      <span
        >For any login issues<br />
        Please contact Herc Rentals Service Desk at <br />
        866-4HERCIT (866-443-7248) or email
        <a href="mailto:HercServiceDesk@hercrentals.com">HercServiceDesk&#64;hercrentals.com</a></span
      >
    </div>
  </div>
</div>
